module.exports = __webpack_public_path__ + "img/BAU Seniors_4.3ea245c5.jpg";